/* Vey's redesign — hero slider.
   Cross-fades the main hero panel's slides + text, auto-rotates, pauses on
   hover/focus, exposes dots. No-ops gracefully with 0/1 slides and respects
   prefers-reduced-motion (no autoplay). */
(function () {
  if (window.customElements && customElements.get('custom-hero-slider')) return;

  class CustomHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.panels = Array.from(this.querySelectorAll('[data-hero-panel]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.count = this.slides.length;
      if (this.count < 2) return;

      this.index = 0;
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 4000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      if (!this.reduceMotion) this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    goTo(i) {
      this.index = ((i % this.count) + this.count) % this.count;
      this.slides.forEach((el, n) => el.classList.toggle('is-active', n === this.index));
      this.panels.forEach((el, n) => el.classList.toggle('is-active', n === this.index));
      this.dots.forEach((el, n) => {
        var on = n === this.index;
        el.classList.toggle('is-active', on);
        el.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    next() {
      this.goTo(this.index + 1);
    }

    start() {
      if (this.reduceMotion || this.timer) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  customElements.define('custom-hero-slider', CustomHeroSlider);
})();
